import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import Button, { type ButtonProps } from '@atlaskit/button/new';

import type { Build } from '../../../types';
import { isBuildEnabled } from '../../../utils';
import { useSolutionPlan } from '../../solution-plan-context';

import { messages } from './messages';

export type ActionButtonProps = ButtonProps & {
	build: Build;
	isComingSoon?: boolean;
	isDisabled?: boolean;
};

export const ActionButton = ({
	build,
	children,
	isComingSoon,
	isDisabled = false,
	...props
}: ActionButtonProps): React.JSX.Element => {
	di(useSolutionPlan);

	const { builds, solutionState } = useSolutionPlan();
	const { formatMessage } = useIntl();

	return (
		<Button
			isDisabled={
				isDisabled || isComingSoon || !isBuildEnabled(build, builds) || solutionState === 'DISABLED'
			}
			{...props}
		>
			{children}
			{isComingSoon && ` (${formatMessage(messages.comingSoonTagLabel)})`}
		</Button>
	);
};
